/**
 * FabVivera Custom JS - Optimized for Performance
 * - Replaced most jQuery logic with Vanilla JS
 * - Implemented Intersection Observer for Slick Slider lazy initialization
 */

document.addEventListener('DOMContentLoaded', () => {
  // Utility for debouncing/throttling
  const throttle = (func, limit) => {
    let lastFunc;
    let lastRan;
    return function () {
      const context = this;
      const args = arguments;
      if (!lastRan) {
        func.apply(context, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function () {
          if ((Date.now() - lastRan) >= limit) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    }
  };

  // --- SLICK SLIDER LAZY INITIALIZATION ---
  const initSlickLazy = (selector, options) => {
    const elements = document.querySelectorAll(selector);
    if (elements.length === 0) return;

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const $el = $(entry.target);
          if (!$el.hasClass('slick-initialized')) {
            $el.slick(options);
          }
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px' });

    elements.forEach(el => observer.observe(el));
  };

  // 1. Announcebar (Critical - initialize early but after main thread)
  setTimeout(() => {
    $('.announcement_bar_slider').slick({
      autoplay: true,
      arrows: false,
      dots: false,
      infinite: true,
      slidesToShow: 1,
      autoplaySpeed: 0,
      speed: 15000,
      variableWidth: true,
      pauseOnHover: false,
      cssEase: 'linear',
      slidesToScroll: 3
    });
  }, 100);

  // 2. Hero Banner (Critical)
  setTimeout(() => {
    $('.hero_banner_slider').slick({
      autoplay: true,
      autoplaySpeed: 2500,
      arrows: false,
      dots: true,
      infinite: true,
      slidesToShow: 1,
      adaptiveHeight: false,
      slidesToScroll: 1
    });
  }, 200);

  // 3. Collection Slider (Lazy)
  initSlickLazy('.collection_slider', {
    arrows: true,
    dots: true,
    slidesToShow: 4,
    autoplay: true,
    infinite: true,
    slidesToScroll: 1,
    autoplaySpeed: 1000,
    prevArrow: $('#collection_slider_prev'),
    nextArrow: $('#collection_slider_next'),
    appendDots: '#collection_slider_dot',
    responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 3 } },
      { breakpoint: 767, settings: { slidesToShow: 2 } },
      { breakpoint: 575, settings: { slidesToShow: 1, centerMode: true, centerPadding: '80px' } },
      { breakpoint: 370, settings: { slidesToShow: 1, centerMode: true, centerPadding: '30px' } }
    ]
  });

  // 3b. Article Slider (Lazy)
  initSlickLazy('.article-slider', {
    arrows: true,
    dots: true,
    slidesToShow: 3,
    autoplay: true,
    infinite: true,
    slidesToScroll: 1,
    autoplaySpeed: 2000,
    prevArrow: $('#article-slider_prev'),
    nextArrow: $('#article-slider_next'),
    appendDots: '#article-slider_dot',
    responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 2 } },
      { breakpoint: 749, settings: { slidesToShow: 1, centerMode: true, centerPadding: '40px' } },
      { breakpoint: 370, settings: { slidesToShow: 1, centerMode: true, centerPadding: '20px' } }
    ]
  });

  // 4. Collection Tabs (Lazy + Multi-init)
  const initCollectionTabs = () => {
    const tabs = document.querySelectorAll('.collection_tab_content_slider');
    tabs.forEach(tab => {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const $el = $(entry.target);
            if (!$el.hasClass('slick-initialized')) {
              $el.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                draggable: false,
                autoplay: true,
                autoplaySpeed: 1000,
                arrows: true,
                dots: true,
                nextArrow: $el.parents(".collection_tab_content_main").find('.collection_tab_next'),
                prevArrow: $el.parents(".collection_tab_content_main").find('.collection_tab_prev'),
                appendDots: $el.parents(".collection_tab_content_main").find('.collection_tab_dot'),
                responsive: [
                  { breakpoint: 1199, settings: { slidesToShow: 3 } },
                  { breakpoint: 767, settings: { slidesToShow: 2 } },
                  { breakpoint: 575, settings: { slidesToShow: 1, centerMode: true, centerPadding: '80px' } },
                  { breakpoint: 370, settings: { slidesToShow: 1, centerMode: true, centerPadding: '40px' } }
                ]
              });
            }
            obs.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px' });
      observer.observe(tab);
    });
  };
  initCollectionTabs();

  // 5. Video Slider (Lazy)
  initSlickLazy('.video_slider', {
    arrows: false,
    centerMode: true,
    centerPadding: '0',
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1400, settings: { slidesToShow: 3 } },
      { breakpoint: 767, settings: { slidesToShow: 1, centerMode: true, centerPadding: '140px' } },
      { breakpoint: 575, settings: { slidesToShow: 1, centerMode: true, centerPadding: '40px' } },
      { breakpoint: 370, settings: { slidesToShow: 1, centerMode: true, centerPadding: '40px' } }
    ]
  });

  // Video autoplay logic (Keep jQuery here for slick events consistency)
  function playActiveVideo() {
    $('.video_slider .slick-slide').each(function () {
      var video = this.querySelector('video');
      if (video) {
        if (this.classList.contains('slick-center')) {
          video.play();
        } else {
          video.pause();
          video.currentTime = 0;
        }
      }
    });
  }

  $('.video_slider').on('afterChange init', function () {
    playActiveVideo();
  });

  // 6. Review Slider (Lazy)
  initSlickLazy('.review_slider', {
    arrows: true,
    dots: true,
    slidesToShow: 3,
    infinite: true,
    slidesToScroll: 1,
    prevArrow: $('.review_slider_prev'),
    nextArrow: $('.review_slider_next'),
    appendDots: '.review_slider_dot',
    responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 2 } },
      { breakpoint: 767, settings: { slidesToShow: 1, centerMode: true, centerPadding: '80px' } },
      { breakpoint: 575, settings: { slidesToShow: 1, centerMode: true, centerPadding: '25px' } },
      { breakpoint: 370, settings: { slidesToShow: 1, centerMode: true, centerPadding: '0' } }
    ]
  });

  // --- VANILLA JS LOGIC FOR TABS, ACCORDION, ETC ---

  // Collection Tab Switching
  document.querySelectorAll('ul.collection_tab_nav li').forEach(li => {
    li.addEventListener('click', function () {
      const tabId = this.getAttribute('data-tab');

      this.parentNode.querySelectorAll('li').forEach(item => item.classList.remove('active'));
      document.querySelectorAll('.collection_tab_content_main').forEach(content => content.classList.remove('active'));

      this.classList.add('active');
      const target = document.getElementById(tabId);
      if (target) {
        target.classList.add('active');
        $(target).find('.collection_tab_content_slider').slick('setPosition');
      }
    });
  });

  // Product Grid Layout
  document.querySelectorAll('.collection_header_button_2, .collection_header_button_4').forEach(btn => {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.collection_header_button').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const grid = document.getElementById('product-grid');
      if (grid) {
        grid.classList.remove('product-grid-2', 'product-grid-4');
        grid.classList.add(this.classList.contains('collection_header_button_2') ? 'product-grid-2' : 'product-grid-4');
      }
    });
  });

  // Footer Accordion (Mobile)
  const initFooterAccordion = () => {
    if (window.innerWidth < 768) {
      document.querySelectorAll('.footer_menu h2').forEach(h2 => {
        h2.addEventListener('click', function () {
          const ul = this.nextElementSibling;
          if (ul && ul.tagName === 'UL') {
            const isActive = this.classList.contains('active');

            // Close others
            document.querySelectorAll('.footer_menu h2').forEach(otherH2 => {
              otherH2.classList.remove('active');
              if (otherH2.nextElementSibling) otherH2.nextElementSibling.style.display = 'none';
            });

            if (!isActive) {
              this.classList.add('active');
              ul.style.display = 'flex';
            }
          }
        });
      });
    } else {
      document.querySelectorAll('.footer_menu ul').forEach(ul => ul.style.display = 'flex');
    }
  };
  initFooterAccordion();
  window.addEventListener('resize', throttle(initFooterAccordion, 200));

  // Product Tabs
  document.querySelectorAll('ul.product_tab_nav li').forEach(li => {
    li.addEventListener('click', function () {
      const tabId = this.getAttribute('data-tab');
      this.parentNode.querySelectorAll('li').forEach(item => item.classList.remove('current'));
      document.querySelectorAll('.product_tab_content').forEach(c => c.classList.remove('current'));
      this.classList.add('current');
      document.getElementById(tabId)?.classList.add('current');
    });
  });

  // Product Accordion
  document.querySelectorAll('.main_product_accordion_header').forEach(header => {
    header.addEventListener('click', function () {
      this.classList.toggle('active');
      const content = this.nextElementSibling;
      if (content) {
        content.style.display = content.style.display === 'block' ? 'none' : 'block';
      }
    });
  });

  // Popups & Share
  document.querySelectorAll('.product-popup-close').forEach(btn => {
    btn.addEventListener('click', function () {
      this.closest('.product-popup')?.classList.remove('active');
    });
  });

  document.querySelectorAll('.main-product-share').forEach(btn => {
    btn.addEventListener('click', function () {
      this.closest('.product-form__input')?.querySelector('.share-button__button')?.click();
    });
  });

  // Infinite Scroll (Throttled)
  let isInProgress = false;
  window.addEventListener('scroll', throttle(() => {
    if (isInProgress) return;
    const serviceSection = document.querySelector('.jj--service-section');
    if (serviceSection) {
      const rect = serviceSection.getBoundingClientRect();
      if (rect.top <= window.innerHeight) {
        const totalPagesEl = document.querySelector('[data-total-pages]');
        const currentPageEl = document.querySelector('[data-current-page]');
        const nextUrlEl = document.querySelector('[data-next-url]');

        if (!totalPagesEl || !currentPageEl || !nextUrlEl) return;

        let totalPages = parseInt(totalPagesEl.value);
        let currentPage = parseInt(currentPageEl.value);

        if (currentPage >= totalPages) return;

        currentPage++;
        currentPageEl.value = currentPage;
        const nextUrl = nextUrlEl.value.replace(/page=[0-9]+/, 'page=' + currentPage);

        isInProgress = true;
        document.querySelector('.loaderWrap')?.classList.add('show');

        fetch(nextUrl)
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newProducts = doc.querySelector('.product-grid')?.innerHTML;
            if (newProducts) {
              document.querySelector('.product-grid').insertAdjacentHTML('beforeend', newProducts);
            }
            isInProgress = false;
            document.querySelector('.loaderWrap')?.classList.remove('show');
          })
          .catch(() => {
            isInProgress = false;
            document.querySelector('.loaderWrap')?.classList.remove('show');
          });
      }
    }
  }, 100));

  // Related Products Multi-init with MutationObserver
  let relObserver = new MutationObserver((mutations, obs) => {
    const element = document.querySelector('.related_collection_slider');
    if (element && !element.classList.contains('slick-initialized')) {
      // Use lazy init for this too
      initSlickLazy('.related_collection_slider', {
        arrows: true,
        dots: true,
        slidesToShow: 4,
        autoplay: true,
        infinite: true,
        slidesToScroll: 1,
        autoplaySpeed: 1000,
        prevArrow: $('#related_collection_slider_prev'),
        nextArrow: $('#related_collection_slider_next'),
        appendDots: '#related_collection_slider_dot',
        responsive: [
          { breakpoint: 1199, settings: { slidesToShow: 3 } },
          { breakpoint: 767, settings: { slidesToShow: 2 } },
          { breakpoint: 575, settings: { slidesToShow: 1, centerMode: true, centerPadding: '80px' } },
          { breakpoint: 370, settings: { slidesToShow: 1, centerMode: true, centerPadding: '40px' } }
        ]
      });
      obs.disconnect();
    }
  });
  relObserver.observe(document.body, { childList: true, subtree: true });

});